export default {
  ADMIN_ACCESS: 'ADMIN_ACCESS',
  ADMIN_MANAGE_STORY: 'ADMIN_MANAGE_STORY',
  ADMIN_MANAGE_USER: 'ADMIN_MANAGE_USER',
  ADMIN_MANAGE_PRODUCT: 'ADMIN_MANAGE_PRODUCT',
  ADMIN_MANAGE_ORDER: 'ADMIN_MANAGE_ORDER'
};
